// src/components/BoardPack/pages/ThirdTable.jsx
import React, { useState, useEffect, useRef } from "react";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import CfoCommentsSmallTable from "../components/tables/CfoCommentsSmallTable";
import { useQueue } from "@/context/QueueContext";
import NoDataComponent from "@/components/common/NoDataComponent";
import HeadingComponent from "../components/shared/heading";
import { processParams } from "../utils/paramsHelper";
import { useNavigate } from "react-router-dom";

const ThirdTable = ({
  year = "",
  month = "",
  monthNumber = "",
  contract = "",
  page = null,
  isExporting = false,       // ✅ export mode
  cfoComment = "",           // ✅ lifted state from BoardPack
  onCfoCommentChange,        // ✅ setter from BoardPack
  isRefresh = false
}) => {
  const [tableData, setTableData] = useState(null);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetchedRef = useRef(false);

  const { enqueue } = useQueue();
const navigate = useNavigate();

  const is_cfo = page?.params?.is_cfo ? true : false;
  const measure = page?.params?.measure ? page?.params?.measure : 0;
  const value_type = page?.params?.value_type ? page?.params?.value_type : 0;

  useEffect(() => {
    if (!year || !month || !contract) return;
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    loadData();
  }, [year, month, contract]);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    setSummary(null);

    try {
      const apiParams = processParams(page?.params || {}, { year, month, contract });

      const response = await enqueue(() =>
        apiCall("GET", "/boardpack/enforcement-monthly-kpi", apiParams,navigate,false,false,isRefresh)
      );

      if (!response?.success) {
        throw new Error(response?.message || "API returned unsuccessful response");
      }
      setTableData(response.data);
      setSummary({
        ai_summary: response?.ai_summary || "",
        lines: response?.lines || [],
      });
    } catch (err) {
      console.error("Error loading data:", err);
      setError(err.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={loadData} />;
  // if(tableData?.rows){
  // return <NoDataComponent  onRetry={loadData} />
  // }

  const title = page?.title || "CFO Comments"
  const subtitle = page?.subtitle

  return (
    <div className="flex relative w-full bg-bg-bw-custom">
      <div className="flex-1 flex flex-col px-6">
        {/* Heading */}
        <div className="flex flex-col gap-1">
        {
          title && <HeadingComponent variant={is_cfo ? "cfo" : "main"}>
            {title}
          </HeadingComponent>
        }
        {
          subtitle && <HeadingComponent variant={is_cfo ? "cfoSub" : "sub"}>
            {subtitle}
          </HeadingComponent>
        }
      </div>

        {/* Text Content */}
        <div className="text-dark-text-custom w-full mb-2 text-[15px]">
          {page?.first_heading && (
            <ul className="list-disc ml-12 space-y-1">
              <li>{page?.first_heading}</li>
            </ul>
          )}
          {page?.second_heading_Bold && (
            <p className="font-bold ml-6 mt-2">{page?.second_heading_Bold}</p>
          )}
          {page?.third_hedaing && (
            <ul className="list-disc ml-12 mt-1">
              <li>{page?.third_hedaing}</li>
            </ul>
          )}
        </div>

        {/* Table — cfoComment + onCfoCommentChange + isExporting pass karo */}
        <CfoCommentsSmallTable
          data={tableData}
          summary={summary}
          loading={loading}
          error={error}
          headerTitle={page?.headerTitle}
          subHeaderTitle={page?.subheaderTitle}
          month={tableData?.month}
          prevMonth={tableData?.prevMonth}
          isExporting={isExporting}
          cfoComment={cfoComment}
          onCfoCommentChange={onCfoCommentChange}
          is_cfo={is_cfo}
        />
      </div>
    </div>
  );
};

export default ThirdTable;